import { AcceleratorsQuotaStats } from "../../../types/AcceleratorQuotaStats";
import { AcceleratorQuotaStatsAction } from "../../actions/acceleratorQuotaStats";
import { AcceleratorQuotaStatsActionKey } from "../../actions/ActionKeys";

export function acceleratorQuotaStats(
  state: AcceleratorsQuotaStats | null = null,
  action: AcceleratorQuotaStatsAction
): AcceleratorsQuotaStats | null {
  switch (action.type) {
    case AcceleratorQuotaStatsActionKey.SET_ACCELERATOR_QUOTA_STATS:
      return action.payload.stats;
    default:
      return state;
  }
}
